import Pagination from "rc-pagination";
import styled from "styled-components";

export default styled(Pagination)`
  .rc-pagination {
    font-size: 12px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0;
  }
  .rc-pagination > li {
    list-style: none;
  }
  .rc-pagination-total-text {
    float: left;
    height: 30px;
    line-height: 30px;
    list-style: none;
    padding: 0;
    margin: 0 8px 0 0;
  }
  .rc-pagination:after {
    content: " ";
    display: block;
    height: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }
  .rc-pagination-item {
    cursor: pointer;
    min-width: 16px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    list-style: none;
    float: left;
    background-color: #fff;
    margin-right: 8px;
  }
  .rc-pagination-item a {
    text-decoration: none;
    color: #666;
    font-size: 0.75rem;
  }
  .rc-pagination-item:hover {
    color: #94d500;
  }
  .rc-pagination-item:hover a {
    color: #94d500;
  }
  .rc-pagination-item-disabled {
    cursor: not-allowed;
  }
  .rc-pagination-item-disabled:hover {
    color: #d9d9d9;
  }
  .rc-pagination-item-disabled:hover a {
    color: #d9d9d9;
  }
  .rc-pagination-item-active {
    color: #94d500;
  }
  .rc-pagination-item-active a {
    color: #94d500;
  }
  .rc-pagination-item-active:hover a {
    color: #94d500;
  }
  .rc-pagination-jump-prev:after,
  .rc-pagination-jump-next:after {
    content: "•••";
    display: block;
    letter-spacing: 2px;
    color: #ccc;
    font-size: 12px;
    margin-top: 1px;
  }
  .rc-pagination-jump-prev:hover:after,
  .rc-pagination-jump-next:hover:after {
    color: #94d500;
  }
  .rc-pagination-jump-prev:hover:after {
    content: "«";
  }
  .rc-pagination-jump-next:hover:after {
    content: "»";
  }
  .rc-pagination-jump-prev-custom-icon,
  .rc-pagination-jump-next-custom-icon {
    position: relative;
  }
  .rc-pagination-jump-prev-custom-icon:after,
  .rc-pagination-jump-next-custom-icon:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transition: all 0.2s;
    content: "•••";
    opacity: 1;
    display: block;
    letter-spacing: 2px;
    color: #ccc;
    font-size: 12px;
    margin-top: 1px;
  }
  .rc-pagination-jump-prev-custom-icon .custom-icon-jump-prev,
  .rc-pagination-jump-next-custom-icon .custom-icon-jump-prev,
  .rc-pagination-jump-prev-custom-icon .custom-icon-jump-next,
  .rc-pagination-jump-next-custom-icon .custom-icon-jump-next {
    opacity: 0;
    transition: all 0.2s;
  }
  .rc-pagination-jump-prev-custom-icon:hover:after,
  .rc-pagination-jump-next-custom-icon:hover:after {
    opacity: 0;
    color: #ccc;
  }
  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-prev,
  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-prev,
  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-next,
  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-next {
    opacity: 1;
    color: #94d500;
  }
  .rc-pagination-prev,
  .rc-pagination-jump-prev,
  .rc-pagination-jump-next {
    margin-right: 8px;
  }
  .rc-pagination-prev,
  .rc-pagination-next,
  .rc-pagination-jump-prev,
  .rc-pagination-jump-next {
    cursor: pointer;
    color: #666;
    font-size: 10px;
    list-style: none;
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    float: left;
    text-align: center;
  }
  .rc-pagination-prev a:after {
    content: "‹";
    display: block;
  }
  .rc-pagination-next a:after {
    content: "›";
    display: block;
  }
  .rc-pagination-prev,
  .rc-pagination-next {
    font-size: 18px;
  }
  .rc-pagination-prev a,
  .rc-pagination-next a {
    color: #666;
  }
  .rc-pagination-prev a:after,
  .rc-pagination-next a:after {
    margin-top: -1px;
  }
  .rc-pagination-disabled {
    cursor: not-allowed;
  }
  .rc-pagination-disabled a {
    color: #ccc;
  }
  .rc-pagination-options {
    float: left;
    margin-left: 15px;
  }
  .rc-pagination-options-size-changer {
    float: left;
    width: 80px;
  }
  .rc-pagination-options-quick-jumper {
    float: left;
    margin-left: 16px;
    height: 28px;
    line-height: 28px;
  }
  .rc-pagination-options-quick-jumper input {
    margin: 0 8px;
    box-sizing: border-box;
    background-color: #fff;
    outline: none;
    padding: 3px 12px;
    width: 50px;
    height: 28px;
  }
  .rc-pagination-options-quick-jumper input:hover {
    color: #94d500;
  }
  .rc-pagination-options-quick-jumper button {
    display: inline-block;
    margin: 0 8px;
    font-weight: 500;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    white-space: nowrap;
    padding: 0 15px;
    font-size: 12px;
    height: 28px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;
  }
  .rc-pagination-options-quick-jumper button:hover,
  .rc-pagination-options-quick-jumper button:active,
  .rc-pagination-options-quick-jumper button:focus {
    color: #94d500;
    background-color: #fff;
  }
  .rc-pagination-simple .rc-pagination-prev,
  .rc-pagination-simple .rc-pagination-next {
    border: none;
    height: 24px;
    line-height: 24px;
    margin: 0;
    font-size: 18px;
  }
  .rc-pagination-simple .rc-pagination-simple-pager {
    float: left;
    margin-right: 8px;
    list-style: none;
  }
  .rc-pagination-simple .rc-pagination-simple-pager .rc-pagination-slash {
    margin: 0 10px;
  }
  .rc-pagination-simple .rc-pagination-simple-pager input {
    margin: 0 8px;
    box-sizing: border-box;
    background-color: #fff;
    outline: none;
    padding: 5px 8px;
    min-height: 20px;
  }
  .rc-pagination-simple .rc-pagination-simple-pager input:hover {
    color: #94d500;
  }
  .rc-pagination-simple .rc-pagination-simple-pager button {
    display: inline-block;
    margin: 0 8px;
    font-weight: 500;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    white-space: nowrap;
    padding: 0 8px;
    font-size: 12px;
    height: 26px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    color: rgba(0, 0, 0, 0.65);
    background-color: #fff;
  }
  .rc-pagination-simple .rc-pagination-simple-pager button:hover,
  .rc-pagination-simple .rc-pagination-simple-pager button:active,
  .rc-pagination-simple .rc-pagination-simple-pager button:focus {
    color: #94d500;
    background-color: #fff;
  }
  @media only screen and (max-width: 1024px) {
    .rc-pagination-item-after-jump-prev,
    .rc-pagination-item-before-jump-next {
      display: none;
    }
  }
`;
